var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB1ElectricityConsumptionOfHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 56h-6V29.27l3-3.07 3 3.07V56zm-16 0h6V34.92l-3-3.07-3 3.07V56zM27 40.58V56h6V40.58l-3-3.07-3 3.07zm-10 7.07V56h6v-8.35l-3-3.07-3 3.07zM73 25.9V69H3V25.89L38.37 3.63 73 25.9zm-4 2.18L38.35 8.37 7 28.1V65h62V28.08z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B1_Electricity_consumption_of_home.6bddb4ee.svg";
export { SvgB1ElectricityConsumptionOfHome as ReactComponent };